import { render } from "./Giubileo.vue?vue&type=template&id=cba0b71c"
import script from "./Giubileo.vue?vue&type=script&lang=js"
export * from "./Giubileo.vue?vue&type=script&lang=js"

import "./Giubileo.vue?vue&type=style&index=0&id=cba0b71c&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__